import { h, JSX } from "preact";
import { forwardRef } from "preact/compat";

import classname from "../../../foundation/utils/classname";
import { imageUrl } from "../../../foundation/utils/image";

import styles from "./SupportButton.module.css";

type NativeButtonProps = Omit<JSX.HTMLAttributes<HTMLButtonElement>, "children">;

interface Props extends NativeButtonProps {
    hasBadge?: boolean;
}

const SupportButton = forwardRef<HTMLButtonElement, Props>(({
    class: cssClass,
    hasBadge,
    ...nativeButtonProps
}, ref) => {
    return (
        <button
            ref={ref}
            {...nativeButtonProps}
            class={classname(styles.supportButton, cssClass)}>
            <img
                alt="lifesaver"
                width="24"
                height="24"
                src={imageUrl("img/icLifeSaver.svg")}/>
            {hasBadge && <div class={styles.badge}/>}
        </button>
    );
});

export default SupportButton;
